import classes from './PriceItemOutput.module.css'

const PriceItemOutput = (props) => {
  // label
  // thbValue
  // forexValue
  // forexSymbol

  return (
    <div className={classes.itemContainer}>
      <div className={classes.itemLabelContainer}>
        <p className={classes.labelText}>{props.label}</p>
      </div>
      <div className={classes.thbContainer}>
        <p className={classes.thbText}>{props.thbValue} THB</p>
      </div>
      <br/>
      {props.forexSelected && (
        <div className={classes.forexContainer}>
          <p className={classes.forexText}>
            {props.forexValue} {props.forexSymbol}
          </p>
        </div>
      )}
    </div>
  )
}

export default PriceItemOutput
